import {
  FaHome,
  FaAddressCard,
  FaProjectDiagram,
  FaBloggerB,
  FaUserGraduate,
} from "react-icons/fa";
import { MdConnectWithoutContact } from "react-icons/md";
export const linkData = [
  {
    id: 1,
    text: "home",
    url: "#home",
    icon: <FaHome />,
  },
  {
    id: 2,
    text: "about",
    url: "#about",
    icon: <FaAddressCard />,
  },
  {
    id: 3,
    text: "projects",
    url: "#project",
    icon: <FaProjectDiagram />,
  },
  {
    id: 4,
    text: "blogs",
    url: "#blog",
    icon: <FaBloggerB />,
  },
  {
    id: 5,
    text: "experience",
    url: "#experience",
    icon: <FaUserGraduate />,
  },
  {
    id: 6,
    text: "contact",
    url: "#contact",
    icon: <MdConnectWithoutContact />,
  },
];
